'use strict';

var utmVars = function () {

    var _init = function _init(utmSource, utmMedium, utmCampaign) {

        if (!sessionStorage.getItem('utms')) {

            var utms = {
                utmSource: utmSource,
                utmMedium: utmMedium,
                utmCampaign: utmCampaign
            };

            sessionStorage.setItem('utms', JSON.stringify(utms));

            putSessionValues(utmSource, utmMedium, utmCampaign);
        } else {

            var utmsSession = sessionStorage.getItem("utms");
            var dataSessionStorage = JSON.parse(utmsSession);

            putSessionValues(dataSessionStorage.utmSource, dataSessionStorage.utmMedium, dataSessionStorage.utmCampaign);
        }
    };

    var putSessionValues = function putSessionValues(utmSource, utmMedium, utmCampaign) {

        var elemUtmSource = document.getElementsByClassName('js-utm-source-value');
        var elemUtmMedium = document.getElementsByClassName('js-utm-medium-value');
        var elemUtmCampaign = document.getElementsByClassName('js-utm-campaign-value');

        if (elemUtmSource > 0) {
            elemUtmSource.value = utmSource;
        }

        if (elemUtmSource > 0) {
            elemUtmMedium.value = utmMedium;
        }

        if (elemUtmSource > 0) {
            elemUtmCampaign.value = utmCampaign;
        }
    };

    return {
        init: _init
    };
}();